import {Component} from '@angular/core';
import {v4 as uuidv4} from "uuid";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'app-resource-video-player',
  templateUrl: './resource-video-player.component.html',
  styleUrls: ['./resource-video-player.component.css']
})
export class ResourceVideoPlayerComponent {
  data: any;

  UUID = uuidv4();

  htmlContent: SafeHtml = '';

  constructor(private domSanitizer: DomSanitizer) {
  }


  ngOnInit() {
    this.getSanitizedContent(this.data.videoUrl)
  }

  getSanitizedContent(content) {
    this.htmlContent = this.domSanitizer.bypassSecurityTrustHtml(content);
  }

  ngAfterViewChecked(): void {
    const slideWrapper = $('.video-wrapper-' + this.UUID);
    const slideWidth = slideWrapper.get(0).getBoundingClientRect().width
    const iframe = $(`.video-wrapper-${this.UUID} iframe`);
    iframe.get(0)?.setAttribute('width', slideWidth.toString());
    iframe.get(0)?.removeAttribute('height');
    iframe.css('aspect-ratio', '3/1.825');
  }
}
